module.exports = __webpack_public_path__ + "static/logo-lostit-acd24d159a81795af0dd603c674e7bb4.svg";